// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"175":"PrototypeViewer","938":"askhub-ui"}[chunkId] || chunkId) + "." + {"21":"dd6db1e0e735bc8de833","173":"afd067083b5410f509da","175":"dd6db1e0e735bc8de833","938":"d8c8a084a7bc7e44bfe4","973":"a8f782c3d884d059ca70"}[chunkId] + ".chunk.css";
};